import { render, staticRenderFns } from "./VideoComments.vue?vue&type=template&id=72f05c4f&scoped=true&"
import script from "./VideoComments.vue?vue&type=script&lang=js&"
export * from "./VideoComments.vue?vue&type=script&lang=js&"
import style0 from "./VideoComments.vue?vue&type=style&index=0&id=72f05c4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f05c4f",
  null
  
)

export default component.exports